/* https://stackoverflow.com/a/7317311 */
export const warnIfExitingWithUnsavedChanges = (
  hasUnsavedChanges: () => boolean
) => {
  const eventFunction = function(e: Event) {
    if (hasUnsavedChanges()) {
      (e || window.event).returnValue = true; //Gecko + IE
      return true; //Gecko + Webkit, Safari, Chrome etc.
    }

    return undefined;
  };

  window.addEventListener("beforeunload", eventFunction);

  return eventFunction;
};

export const removeChangesNotSavedWarning = (
  funcToUnmount: (e: Event) => void
) => {
  window.removeEventListener("beforeunload", funcToUnmount);
};
